// Import React
import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Banner = () => {
  
  // Define your settings for the slider
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1, 
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    arrows: true, // Hide arrows
  };

  return (
    <div className='main_banner'>
      {/* Add the Slider component with the defined settings */}
      <Slider {...settings}>
        <div className='main_banner_img'>
           <img src="/images/main_banner_design.jpg" alt="Main Banner" />
        </div>
        <div className='main_banner_img'>
           <img src="/images/main_banner_design_02.jpg" alt="Main Banner" />
        </div>
      </Slider>
    </div>
  );
}

export default Banner;
